/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";
import cx from "classnames";

import styles from "./ProgressBar.module.scss";

export interface ProgressBarProps {
  progress: number;
  className?: string;
}

export const ProgressBar = ({ progress, className }: ProgressBarProps) => {
  const progressBarStyle: React.CSSProperties = {
    width: `${progress}%`,
  };

  return (
    <div className={cx(styles.progressBar, className)}>
      <div className={styles.bar} style={progressBarStyle} />
    </div>
  );
};

export default ProgressBar;
